// removed by extract-text-webpack-plugin
module.exports = {"tooltipContainer":"_3RzOoHVyY0O6VhqyQ2npg0","tooltip":"CtI-j50VeoLBOT5md-5N_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BottomTooltip/BottomTooltip.scss
// module id = 1554
// module chunks = 0